import { render, staticRenderFns } from "./BoardTeacher.vue?vue&type=template&id=13a481d5&"
import script from "./BoardTeacher.vue?vue&type=script&lang=js&"
export * from "./BoardTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports